export default "__VITE_ASSET__DrcL9$vL__"